module.exports = __webpack_public_path__ + "img/pcrown1.ee3a4399.png";